<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="600">
			<v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4']">
				<v-card-title class="text-h5">
					¡Hola!
				</v-card-title>

				<v-card-subtitle>
					Estimado cliente.
				</v-card-subtitle>

				<v-card-text>
					<v-stepper v-model="step" class="elevation-0">
						<v-stepper-items>
							<v-stepper-content step="1" class="pa-0">
								<v-card class="pa-0">
									<v-card-text class="pt-0">
										<v-row
											style="height: 375px;"
											align="center"
										>
											<v-col
												cols="12"
												class="d-flex flex-column justify-center align-center pa-0"
											>
												<img
													src="/img/1.png"
													alt=""
													height="300px"
												/>
												<p
													class="text-center mt-2"
													style="font-size: 1.1rem;"
												>
													Hemos puesto a tu
													disposición esta herramienta
													la cual te permitirá
													agilizar la captura y envío
													de tus órdenes de compra y
													ofrecerte un mejor servicio.
												</p>
											</v-col>
										</v-row>
									</v-card-text>
									<v-card-actions
										class="d-flex justify-end pa-0"
									>
										<v-btn
											color="primary"
											@click="step = 2"
										>
											Continuar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>

							<v-stepper-content step="2" class="pa-0">
								<v-card class="pa-0">
									<v-card-text class="pt-0">
										<v-row
											style="height: 375px;"
											align="center"
										>
											<v-col
												cols="12"
												class="d-flex justify-center pa-0"
											>
												<img
													src="/img/2.png"
													alt=""
													height="300px"
												/>
											</v-col>

											<v-col
												cols="12"
												class="d-flex flex-column justify-center align-center text-center pa-0"
											>
												<p style="font-size: 1.1rem;">
													Realizar la captura de tus
													órdenes de compra es más
													sencillo. Puedes hacerlo en
													cualquier momento y desde
													cualquier lugar.
												</p>
											</v-col>
										</v-row>
									</v-card-text>

									<v-card-actions
										class="d-flex justify-space-between pa-0"
									>
										<v-btn text @click="step = 1">
											regresar
										</v-btn>

										<v-btn
											color="primary"
											@click="step = 3"
										>
											Continuar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>

							<v-stepper-content step="3" class="pa-0">
								<v-card class="pa-0">
									<v-card-text class="pt-0">
										<v-row
											style="height: 375px;"
											align="center"
										>
											<v-col
												cols="12"
												class="d-flex justify-center align-center pa-0 text-center flex-column"
											>
												<img
													src="/img/3.png"
													alt=""
													height="225px"
												/>

												<p style="font-size: 1.1rem;">
													En pocos pasos.
												</p>
											</v-col>
											<v-col
												cols="12"
												class="d-flex justify-space-around pa-0"
											>
												<div
													class="d-flex flex-column justify-center align-center text-center"
												>
													<v-avatar
														size="25"
														class="white--text"
														color="primary"
													>
														1
													</v-avatar>
													Selecciona los artículos
												</div>
												<div
													class="d-flex flex-column justify-center align-center text-center"
												>
													<v-avatar
														size="25"
														class="white--text"
														color="primary"
													>
														2
													</v-avatar>
													Selecciona las cantidades
												</div>
												<div
													class="d-flex flex-column justify-center align-center text-center"
												>
													<v-avatar
														size="25"
														class="white--text"
														color="primary"
													>
														3
													</v-avatar>
													Envia tu pedido
												</div>
											</v-col>
										</v-row>
									</v-card-text>

									<v-card-actions
										class="d-flex justify-space-between pa-0"
									>
										<v-btn text @click="step = 2">
											regresar
										</v-btn>

										<v-btn
											color="primary"
											@click="dialog = false"
										>
											Terminar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	name: "Wellcome",

	data() {
		return {
			dialog: true,
			step: 1,
		};
	},
};
</script>

<style lang="css" scoped></style>
